import { Folder, FolderState } from './folder.model';
import { Layer, LayerDocumentUIdsSet, LayerExtraGeoFields, LayerState, LayerTypes } from './layer.model';
import { DatasetsSet } from 'src/app/modules/core/store/models/dataset.model';
import { Document, DocumentsSet } from 'src/app/modules/core/store/models/document.model';
import { MapPosition } from '../../../drawing/models/map-position.model';
import { BetaOptions, MapTypeSettings, SectionWidgetUserSettings } from '../../lsd/models/map-configuration.model';

export interface Map {
  uId?: string | null;
  name: string | null;
  createdOn: string | null;
  updatedOn: string | null;
  lastEditedByName: string | null;
  lastEditedById: string | null;
  isActive: boolean;
  folders: Folder[] | null;
  version?: number;
  displaySettings?: string;
  mapLinkId?: string;
  wallConfiguration?: string;
}

export interface MapWithState {
  map: Map;
  foldersSet: { [folderUId: string]: Folder };
  folderStates: { [folderUId: string]: FolderState };
  layers: Layer[];
  layersSet: { [layerUId: string]: Layer };
  layerStates: { [layerUId: string]: LayerState };
  workflowStatusVisibility: { [key: string]: string[] };
  sectionWidgetUserSettings?: { [sectionUId: string]: SectionWidgetUserSettings };
  hiddenDocumentsByLayer?: LayerDocumentUIdsSet;
  documentsSet: DocumentsSet;
  datasetsSet: DatasetsSet;
  selectedDocuments: DocumentsSet;
  geoFieldsForOptionalDisplay?: LayerExtraGeoFields[];
}

export interface MapLink {
  uId?: string | null;
  organizationUId: string | null;
  createdOn: string | null;
  mapUId: string | null;
  createdByName: string | null;
  createdById: string | null;
  token?: string;
}

export interface MapLayerView {
  datasetUId?: string | null;
  organizationUId: string | null;
  mapName: string | null;
  mapUId: string | null;
  layerName: string | null;
  layerUId: string | null;
  layerType?: LayerTypes;
}

export interface MapSettings {
  tropicalCycloneExpanded?: { [key: string]: boolean };
  folderExpanded?: { [key: string]: boolean };
  folderVisibility?: { [key: string]: number };
  layerVisibility?: { [key: string]: boolean };
  layerOpacity?: { [key: string]: number };
  workflowStatusVisibilityByLayerTypeAndName?: { [key: string]: string[] };
  workflowStatusExpandedByLayerTypeAndName?: { [sectionUId: string]: string[] };
  sectionWidgetUserSettings?: { [sectionUId: string]: SectionWidgetUserSettings };
  hiddenDocumentsByLayer?: LayerDocumentUIdsSet;
  geoFieldsForOptionalDisplay?: LayerExtraGeoFields[];
  layerQuickFilterSelections?: { [layerUId: string]: { [filterUId: string]: { selectedValues: any[] } } };
  mapPosition?: MapPosition;
  isLeftDrawerOpen?: boolean;
  floorPlanFilter?: string;
  mapTypeSettings?: MapTypeSettings;
  betaOptions?: BetaOptions;
}

export interface WeatherDocument {
  documentUId: string;
  documentName: string;
  layerUId: string;
  properties?: { isActive: boolean; stormCategory: string };
}

export interface DocumentsToDelete {
  datasetUId?: string;
  documents: Document[];
}

export const TemporaryLayerUIds = {
  SelectedDocumentLayerUId: '2c9d2600-896c-474f-acc1-5a64c4b3885f'
};

export const TemporaryFolderUIds = {
  SelectedDocumentFolderUId: '2ebab9d1-e1df-40f9-b284-914ab698a672'
};

// export const MapTheme = {
//   'light-0':
// }
